import React from 'react';
import styled from 'styled-components';

import { Label, Icon } from 'semantic-ui-react';

export const ActionLabel = styled(Label)`
  margin: 3px;
  cursor: pointer;
`;

export const StyledIcon = styled(Icon)`
  margin: auto !important;
  color: white;
`;

export const VideoChatContainer = styled.div`
  position: fixed;
  z-index: 100;
  background-color: #081216fc;
  border-radius: 4px 4px 0px 0px;
${({ minimised }) => (minimised ? `
  bottom: 0;
  box-shadow: 0px 10px 10px rgba(0,0,0,0.2);
  border-radius-top-left: 4px;
  display: flex;
  flex-direction: column;
  right: 0;
  width: 300px;
` : `
  bottom: 5vh;
  z-index: 1000;
  padding-left: 10px;
  padding-right: 10px;
  height: 95vh
  left:5vh;
  border-radius: 4px;
  right: 5vh;
  margin: auto;
  top: 5vh;
  max-height: 95%
  `)}
`;

export const Audio = ({ toggleAudio, muted }) => (
  <ActionLabel onClick={() => toggleAudio()} style={{ backgroundColor: muted ? '#d92525' : '#4f4c4c' }} circular size="big">
    <StyledIcon size="small" name={muted ? 'microphone slash' : 'microphone'} />
  </ActionLabel>
);

export const Video = ({ toggleCamera, cameraOff }) => (
  <ActionLabel onClick={() => toggleCamera()} style={{ backgroundColor: cameraOff ? '#d92525' : '#4f4c4c' }} circular size="big">
    <StyledIcon size="small" name="video" />
  </ActionLabel>
);

export const Logout = ({ leaveRoom }) => (
  <ActionLabel onClick={() => leaveRoom()} style={{ backgroundColor: '#d92525' }} circular size="big">
    <StyledIcon size="small" name="phone" style={{ transform: 'rotate(223deg)' }} />
  </ActionLabel>
);
